module.exports = __webpack_public_path__ + "img/IMG_2399_T_L_WoodMatted.36d585c6.jpg";